<section class="h-100">
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.INSIGHTS' | translate }}</h1>
  </div>

  <div class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface">
    <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="selectionControl" [itemsSource]="selection"></astral-select>
    </astral-layout-group>
  </div>

  @if (selectedUrl) {
    <iframe [src]="selectedUrl"></iframe>
  }
</section>
